import { Columns, Column, Card, Box } from 'braid-design-system';
import type React from 'react';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';
import LayoutBox from 'src/components/LayoutBox/LayoutBox';
import HooraySvg from 'src/images/Hooray.svg';

import { PaymentContainer } from '../PaymentContainer';

interface PaymentSuccessLayoutProps {
  callToAction: React.ReactNode;
  children: React.ReactNode;
}

export const PaymentSuccessLayout = ({
  callToAction,
  children,
}: PaymentSuccessLayoutProps) => (
  <PaymentContainer>
    <Box marginY="gutter">
      <Columns space="small" collapseBelow="desktop">
        <Column width="3/5">
          <Card>
            <LayoutBox minHeight={200}>
              <Box marginTop="medium">{children}</Box>
            </LayoutBox>
          </Card>

          {callToAction}
        </Column>

        <Column>
          <Box padding="xxlarge">
            <CustomSvg svg={HooraySvg} />
          </Box>
        </Column>
      </Columns>
    </Box>
  </PaymentContainer>
);
